import React from 'react'
import useWpJson from '../../Hooks/useWpJson'
import LodgingGalleryMap from './LodgingGalleryMap'
import Loader from '../../Components/Loader'
import { setMargin, setPadding } from '../../utilities'

export default function LodgingGallery ({
  pageName,
  gallery,
  background_color,
  font_color,
  margin_selection,
  padding_selection,
  full_screen
}) {
  const nameConditions =
    pageName === 'lodging' ? 'justify-end' : 'justify-center'
  const ids = gallery?.map(({ ID }) => ID).join(',')
  const catId = useWpJson(`posts?include=${ids}&acf_format=standard`)
  const pageStyles = {
    ...(background_color && { background: background_color || 'light-gray' }),
    ...(font_color && { color: font_color || 'black' }),
    ...(setMargin(margin_selection) && { margin: setMargin(margin_selection) }),
    ...(setPadding(padding_selection) && {
      padding: setPadding(padding_selection)
    })
  }
  return catId?.length > 0 ? (
    <div
      style={{ ...pageStyles }}
      className={`py-6 lg:py-24 flex flex-row w-full m-auto items-center ${nameConditions} relative `}
      id={pageName}
    >
      <div
        className={`flex flex-col lg:flex-row w-full m-auto items-center ${nameConditions} gap-4 relative ${
          full_screen ? '' : 'max-w-sitemax'
        }`}
      >
        <LodgingGalleryMap jsonResponse={catId} />
      </div>
    </div>
  ) : (
    <div
      className={`flex flex-col lg:flex-row w-full m-auto items-center ${nameConditions} gap-4 relative`}
      id={pageName}
    >
      <Loader />
    </div>
  )
}
